<template>
  <div class="width-100">
    <h2 class="section-title">{{ $t('uploadDocument.title') }}</h2>

    <div class="upload-document">
      <div class="upload-document__upload">
        <div
          v-if="file"
          class="upload-label"
        >
          {{ $t('uploadDocument.uploadLabel') }}
        </div>
        <el-upload
          ref="upload"
          :class="{ 'document-uploader--hidden': file }"
          class="document-uploader"
          action=""
          :limit="1"
          :show-file-list="true"
          :auto-upload="false"
          :multiple="false"
          accept=".pdf"
          :on-change="handleChange"
          :on-remove="handleRemove"
        >
          <i class="el-icon-plus document-uploader__icon"></i>
        </el-upload>
      </div>
      <div
        v-if="fileUrl"
        class="upload-document__preview"
      >
        <PdfPreviewer
          :source="fileUrl"
          @confirm-sign-area="sendPdfToSign"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import PdfPreviewer from '@/components/PdfPreviewer.vue';
  import { samplesApi } from '@/api';

  export default {
    name: 'UploadDocument',
    components: {
      PdfPreviewer,
    },
    props: {
      revisionData: {
        type: Object,
        default: null,
      },
      isAdvancedRevision: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        file: null,
        fileUrl: null,
      };
    },
    methods: {
      handleChange(file) {
        const isPdf = file.raw.type === 'application/pdf';
        if (!isPdf) {
          this.$message.error('The uploaded file is not a pdf');
          this.$refs.upload.clearFiles();
        }
        this.file = isPdf ? file : null;
        if (this.file) {
          this.fileUrl = URL.createObjectURL(this.file.raw);
        }
      },
      handleRemove() {
        this.file = null;
        this.fileUrl = null;
      },
      async uploadDocument(position) {
        return samplesApi.sendPdfToSign(
          this.$route.params.labSampleId,
          this.file.raw,
          position
        );
      },
      async uploadChallengeRevision(position) {
        return samplesApi.createRevisionChallenge(
          {
            labSampleId: this.$route.params.labSampleId,
            report: this.file.raw,
            position,
            data: this.revisionData,
          },
          this.isAdvancedRevision
        );
      },
      async sendPdfToSign(position) {
        if (!Object.keys(position).length) return;

        const loading = this.$loading({
          lock: true,
          background: 'rgba(48,53,82,0.9)',
        });

        try {
          const uploadAction = this.revisionData
            ? this.uploadChallengeRevision
            : this.uploadDocument;

          await uploadAction(position);
          const destination = this.isAdvancedRevision
            ? 'advancedRevisionIndex'
            : 'analysisStatusManagementIndex';

          this.$router.push({ name: destination });
          this.$notify({
            showClose: true,
            type: 'success',
            message: this.$t('uploadDocument.successMessage'),
          });
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        } finally {
          loading.close();
        }
      },
    },
  };
</script>

<style lang="scss">
  .upload-document {
    &__upload {
      margin-bottom: 2rem;

      .upload-label {
        color: $--color-white;
      }

      .document-uploader {
        .el-upload-list {
          max-width: 300px;
        }
        .el-upload {
          border: 1px dashed $--color-white;
          border-radius: 5px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        .el-icon-document {
          display: none;
        }

        &__icon {
          font-size: 28px;
          color: $--color-white;
          width: 178px;
          height: 178px;
          line-height: 178px;
          text-align: center;
        }

        &__signature {
          width: 100%;
          height: auto;
          display: block;
        }

        &--hidden {
          .el-upload {
            display: none;
          }
        }
      }
    }
  }
</style>
